import axios from "axios";
import { i18n } from "@rmp/core/plugins";
import AccessForbiddenException from "@rmp/core/exceptions/accessForbiddenException";
import ApiException from "@rmp/core/exceptions/apiException";
import BadRequestException from "@rmp/core/exceptions/badRequestException";
import HttpNotFoundException from "@rmp/core/exceptions/httpNotFoundException";
import InvalidBusinessOperationException from "@rmp/core/exceptions/invalidBusinessOperationException";
import OfflineException from "@rmp/core/exceptions/offlineException";
import ProblemDetailsException from "@rmp/core/exceptions/problemDetailsException";
import RequestCancelledException from "@rmp/core/exceptions/requestCancelledException";
import ServerUnavailableException from "@rmp/core/exceptions/serverUnavailableException";
import { getProblemDetailsText } from "@rmp/core/api/errors/problemDetails";

export const classifyError = (error: unknown): ApiException => {
	if(error instanceof ApiException) {
		return error;
	}
	
	if(axios.isCancel(error)) {
		return new RequestCancelledException();
	}
	
	const url = axios.isAxiosError(error) ? error.config?.url ?? "" : "";
	
	if(axios.isAxiosError(error) && error.response) {
		const { title, detail } = getProblemDetailsText(error.response.data);
		
		if(error.response.status === 400) {
			return new BadRequestException(title, detail);
		}
		
		if(error.response.status === 409) {
			return new InvalidBusinessOperationException(title, detail);
		}
		
		if(error.response.status === 404) {
			return new HttpNotFoundException(url);
		}
		
		if(error.response.status === 403) {
			return new AccessForbiddenException(url);
		}
		
		console.error(i18n.t("logs.error.requestError"), error.response.data);
		return new ProblemDetailsException(title, detail);
	}
	
	if(navigator.onLine) {
		console.error(error);
		return new ServerUnavailableException(url);
	}
	
	return new OfflineException(url);
};

export const normalizeError = (error: unknown): Error => {
	if(axios.isAxiosError(error)) {
		return classifyError(error);
	}
	
	if(error instanceof Error) {
		return error;
	}
	
	return new Error(String(error));
};
